import { useContext } from "react";
import StyleContext from "src/contexts/StyleContext";

const useStyle = () => {
	const ctx = useContext(StyleContext);
	return { theme: ctx.theme };
};
export default useStyle;
